let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bZpxK")).then(() => parcelRequire('83SWF'));